import { gql } from '@apollo/client'

export const createPurchaseOrderDocumentLinkQuery = gql`
  mutation createPurchaseOrderDocumentLink($input: CreatePurchaseOrderDocumentLinkArgs!) {
    createPurchaseOrderDocumentLink(input: $input) {
      token
      expiresAt
    }
  }
`
